import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * UI strings. Uzbek (Latin) is the source language of the design; other locales fall back to it
 * key by key, so a missing translation shows Uzbek rather than a raw key.
 *
 * Every feature owns its strings in `src/features/<feature>/locales/<lng>.json` (namespace = feature
 * folder name) — no shared JSON file to fight over. Global strings live in `src/shared/i18n/locales`
 * (namespace `translation`, the default).  Usage: `useTranslation('employees')` → `t('table.title')`.
 */
const files = import.meta.glob<{ default: Record<string, unknown> }>(
  ['./locales/*.json', '../../features/*/locales/*.json', '../../app/*/locales/*.json'],
  { eager: true },
);

const resources: Record<string, Record<string, Record<string, unknown>>> = {};
for (const [file, mod] of Object.entries(files)) {
  const lng = file.split('/').pop()!.replace('.json', '');
  const feature = /\/(?:features|app)\/([^/]+)\/locales\//.exec(file)?.[1];
  const ns = feature ?? 'translation';
  resources[lng] ??= {};
  resources[lng][ns] = { ...resources[lng][ns], ...mod.default };
}

void i18n.use(initReactI18next).init({
  resources,
  lng: 'uz-Latn',
  fallbackLng: 'uz-Latn',
  defaultNS: 'translation',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
